import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const components = defineNamespace('components', fr, en);
